import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import axios from "axios";
import { Toaster } from "@/components/ui/sonner";

// Pages
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import FruitsLegumes from "@/pages/FruitsLegumes";
import Cremerie from "@/pages/Cremerie";
import Lots from "@/pages/Lots";
import Viandes from "@/pages/Viandes";
import Charcuterie from "@/pages/Charcuterie";
import Conserves from "@/pages/Conserves";
import Desserts from "@/pages/Desserts";
import Promotions from "@/pages/Promotions";
import Contact from "@/pages/Contact";
import Admin from "@/pages/Admin";
import Setup from "@/pages/Setup";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

function App() {
  useEffect(() => {
    // Seed initial data on first load
    const seedData = async () => {
      try {
        await axios.post(`${API}/seed`);
      } catch (e) {
        console.log("Seed already done or error:", e.message);
      }
    };
    seedData();
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<Home />} />
            <Route path="fruits-legumes" element={<FruitsLegumes />} />
            <Route path="cremerie" element={<Cremerie />} />
            <Route path="lots" element={<Lots />} />
            <Route path="viandes" element={<Viandes />} />
            <Route path="charcuterie" element={<Charcuterie />} />
            <Route path="conserves" element={<Conserves />} />
            <Route path="desserts" element={<Desserts />} />
            <Route path="promotions" element={<Promotions />} />
            <Route path="contact" element={<Contact />} />
          </Route>
          <Route path="/admin/*" element={<Admin />} />
          <Route path="/setup" element={<Setup />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
